import axios from 'services/axiosInstance';
import { DEFAULT_SKIP, LIMIT_ALL } from 'consts/table';

const schoolsIncludedInUnionCache: Record<string, Promise<any[]> | undefined> = {};

export function getAllSchoolsIncludedInUnion(activeSchoolId: string) {
   if (schoolsIncludedInUnionCache[activeSchoolId]) {
      return schoolsIncludedInUnionCache[activeSchoolId];
   }

   const config = {
      params: {
         filter: {
            skip: DEFAULT_SKIP,
            limit: LIMIT_ALL,
            view: {
               type: 'publicWebSite'
            }
         }
      }
   };

   schoolsIncludedInUnionCache[activeSchoolId] = axios
      .get(`${window.apiBase}/public/schools/${activeSchoolId}/schools`, config)
      .then(response => {
         return response.data;
      })
      .catch(error => {
         delete schoolsIncludedInUnionCache[activeSchoolId];
         throw error;
      });

   return schoolsIncludedInUnionCache[activeSchoolId];
};
